import UploadResumeFloating from "../UploadResumeFloating";

const MTPUploadResumeFloating =() => {
    return (
        <UploadResumeFloating
            signupSource="mtp_floating_resume"
        />
    );
};

export default MTPUploadResumeFloating;